<template lang="pug">
.rewards-border(:class="classType")
  slot
</template>

<script>

export default {
  name: "RewardsBorder",
  props: {
    type: {
      type: String,
      default: "bronze",
    },
  },
  computed: {
    classType() {
      return `rewards-border--${this.type}`;
    },
  },
};
</script>
